import * as Sentry from '@sentry/vue';

const rate = (v, d) => {
  return v === undefined || v === '' ? d : Number(v);
};
const API_HOST = process.env.VUE_APP_ROOT_DEFAULT_API || '';
const scrubUrl = (u) => {
  return typeof u === 'string' ? u.replace(/([?&](?:magicToken|token)=)[^&#]*/gi, '$1[Filtered]') : u;
};

export function initSentry(Vue, router) {
  if (!process.env.VUE_APP_SENTRY_DSN) return;
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.VUE_APP_VERSION,
    logErrors: true, // still log to console (v7 swallows otherwise)
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: [API_HOST].filter(Boolean), // NOT the labs API (would break its CORS)
      }),
      new Sentry.Replay({ maskAllText: false, blockAllMedia: false, networkDetailAllowUrls: [] }),
      // Masking disabled per product decision — full-fidelity replays (text + media captured).
      // networkDetailAllowUrls stays EMPTY so request/response BODIES (which carry auth tokens)
      // are still never recorded; the beforeSend/beforeBreadcrumb scrubbers keep tokens out of URLs.
    ],
    tracesSampleRate: rate(process.env.VUE_APP_SENTRY_TRACES_RATE, 1.0),
    replaysSessionSampleRate: rate(process.env.VUE_APP_SENTRY_REPLAY_SESSION_RATE, 1.0),
    replaysOnErrorSampleRate: rate(process.env.VUE_APP_SENTRY_REPLAY_ERROR_RATE, 1.0),
    beforeBreadcrumb(bc) {
      if (bc && bc.data && bc.data.url) bc.data.url = scrubUrl(String(bc.data.url));
      return bc;
    },
    beforeSend(event) {
      if (event.request) {
        if (event.request.headers) delete event.request.headers.Authorization;
        if (event.request.url) event.request.url = scrubUrl(event.request.url);
        if (typeof event.request.query_string === 'string') event.request.query_string = scrubUrl(`?${event.request.query_string}`).slice(1);
      }
      return event;
    },
  });
}
export function setSentryUser(u) { if (u) Sentry.setUser({ id: u.id, email: u.email }); }
export function clearSentryUser() { Sentry.setUser(null); }
